import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { type RequestableApproverParams } from '@webapp/modules/expense/data-access/repositories/ApproverRepository'
import { RequestableApproverOption } from '@webapp/modules/expense/entities/RequestableApproverOption'
import { approverQueryConfig } from '@webapp/modules/expense/query-configs/approver'

type UseQueryRequestableApproversReturn = {
  data: RequestableApproverOption[]
  isLoading: boolean
  error: unknown
}

export const useQueryRequestableApprovers = (
  params: RequestableApproverParams
): UseQueryRequestableApproversReturn => {
  const config = approverQueryConfig.requestableApprovers(params)

  const {
    data: raw,
    isLoading,
    error,
  } = useQuery({
    queryKey: config.queryKey,
    queryFn: config.queryFn,
    enabled: params.department > 0 && params.baseContentTypeId > 0,
  })

  const data = useMemo(
    () => (raw || []).map((item) => new RequestableApproverOption(item)),
    [raw]
  )

  return {
    data,
    isLoading,
    error,
  }
}
